// extracted by mini-css-extract-plugin
export default {"root":"PagePlan_root__KgTot","operation":"PagePlan_operation__odaaP"};